module.exports = __webpack_public_path__ + "static/media/29COICT9.c81900e9.jpg";